<template>
  <div class="app_container">
    <div class="info_item">
      <div class="title">直播名称：</div>
      <div class="info">{{detailInfo.name}}</div>
    </div>
    <div class="info_item">
      <div class="title">直播时间：</div>
      <div class="info">{{detailInfo.startDate}}至{{detailInfo.endDate}}</div>
    </div>
    <div class="info_item">
      <div class="title">推流地址：</div>
      <div class="info">{{detailInfo.streamingAddress}}</div>
      <butn class="m-l-24" title="复制" @click.native="copyText(detailInfo.streamingAddress)"></butn>
    </div>
    <div class="info_item">
      <div class="title">串流码：</div>
      <div class="info">{{detailInfo.streamingCode || "暂无"}}</div>
      <butn class="m-l-24" title="复制" @click.native="copyText(detailInfo.streamingCode)"></butn>
    </div>
    <div class="info_item">
      <div class="title">推流合并地址：</div>
      <div class="info">{{detailInfo.streamingSumAddress}}</div>
      <butn class="m-l-24" title="复制" @click.native="copyText(detailInfo.streamingSumAddress)"></butn>
    </div>
    <div class="info_item">
      <div class="title">上线时间：</div>
      <div class="info">{{detailInfo.onlineDateStr || "暂无"}}</div>
    </div>
  </div>
</template>

<script>
import butn from "@/components/button/index";
export default {
  components: {
    butn
  },
  props: {
    detailInfo: {
      type: Object,
      default: () => {},
    },
    liveRoomId: {
      type: String,
      default: () => ""
    }
  },
  created() {},
  methods: {
    copyText(text = "") {
      this.$copyText(text).then(e => {
        this.$message.success("复制成功");
      }, e => {
        this.$message.warning("复制失败");
      })
    }
  }
}
</script>
<style lang="scss" scoped>
.info_item {
  display: flex;
  flex-direction: row;
  align-items: center;
  line-height: 32px;
  font-size: 1rem;
  margin-bottom: 12px;
  .title {
    color: #536984;
    width: 110px;
    text-align: right;
  }
  .info {
    color: #000000;
  }
}
.m-l-24 {
  margin-left: 24px;
}
</style>